// eslint-disable-next-line max-len
export default "<svg data-name=\"icon/wiki_help\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path data-name=\"Path 303\" d=\"M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm1.2 18h-2.4v-7.2h2.4zm0-9.6h-2.4V6h2.4z\" fill=\"#ff3700\"/></svg>";
